import Vue from 'vue/dist/vue.esm'
import template from './objectives_multiselect_template.slim'
import withScrollToTop from '../../../mixins/with_scroll_to_top.js'

Vue.component('objectives-multiselect', {
  mixins: [template, withScrollToTop],
  props: ['value', 'objectives_options', 'errors', 'required', 'label_text'],
  data() {
    return {
      hasFocus: false,
    }
  },
  methods: {
    updateObjectives(value) {
      this.$emit('input', value)
    },
    toggleFocus(e) {
      e.stopPropagation()
      e.preventDefault()
      if (this.hasFocus) {
        $('body').focus()
      } else {
        this.$refs.objectivesSelect.$el.focus()
      }
      this.hasFocus = !this.hasFocus
    },
  },
})
